import { Random } from '@framework/Random';
import type { FileContainerId } from 'balus-common';

const length = 20;
export const newFileContainerId = (): FileContainerId => Random.generateRandomID(length, 'FC');
